import React, { useCallback } from 'react';
import { getIn, useFormikContext } from 'formik';
import { UdsFC } from '../../../types';
import { DateTimePicker, DateTimePickerProps } from '../../DateTimePicker/DateTimePicker';
import { useAppFormControlContext } from './appFormControlContext';
import { appFormDataTestFactory } from './appFormDataTestFactory';

export const AppFormDateTimePicker: UdsFC<Partial<DateTimePickerProps>> = (props) => {
  const context = useAppFormControlContext();
  const { values, setFieldValue, setFieldTouched } = useFormikContext();
  const name = 'name' in props ? props.name : context.name;
  const value = 'value' in props ? props.value : name ? getIn(values, name) : undefined;
  const onChange = props.onChange;
  const handleOnChange = useCallback(
    (value: string | null) => {
      if (onChange) {
        onChange(value);
      } else if (name) {
        setFieldTouched(name);
        setFieldValue(name, value);
      }
    },
    [name, onChange, setFieldTouched, setFieldValue]
  );
  return (
    <DateTimePicker
      {...props}
      value={value}
      onChange={handleOnChange}
      data-test={appFormDataTestFactory(props.dataTest ?? context.dataTest).input}
    />
  );
};
